import { useContext } from 'react';
import MyContext from '@/shared/contexts/AppContext';
import { ModuloSistema } from '@/shared/constants/modulos-sistema.enum';

export default function RelatoriosUserLabel(props: { className?: string }) {
  const context = useContext(MyContext);
  if (!context)
    return null;

  const { state } = context;
  const navbarVisivel =
    state.navbar &&
    !(state.modulo === ModuloSistema.RelatoriosAtividades && !state.username?.trim());

  if (navbarVisivel) return null;

  const identificacao = state.nome?.trim() || state.username?.trim() || state.cpf?.trim() || '';
  if (!identificacao) return null;

  return (
    <small className={`text-muted ${props.className || ''}`.trim()}>
      <strong>Usuário:</strong> {identificacao}
    </small>
  );
}

